<div class="dashboard">
  <h1>Painel</h1>
</div>
